// extracted by mini-css-extract-plugin
module.exports = {"news":"News_news__l_WIF","buttonWrapper":"News_buttonWrapper__QeLP8","blogPostsSmallLink":"News_blogPostsSmallLink__LWBa_","blogPostsSmall":"News_blogPostsSmall__n1UA8"};